module.exports = __webpack_public_path__ + "41de3ff81e7f85bc47555838d6f58158.png";